export default [
  {
    name: 'custom_header_dewarmsteweek',
    path: 'modules/pages/dewarmsteweek/HeaderDewarmsteweek'
  },
  {
    name: 'projects_overview_dewarmsteweek',
    path: 'modules/pages/dewarmsteweek/ProjectsOverviewDewarmsteweek'
  }
]
